import React from 'react'
import { Container, Nav, Navbar } from 'react-bootstrap'
// import {LinkContainer } from 'react-router-bootstrap'

const Navigationbar = () => {
  return (
    <div id='navbar'>
      <Navbar collapseOnSelect expand='lg' className='navigation sticky' >
        <Container>          
            <Navbar.Brand href='#' className='brand-sec' >
              <img src='logo.png' className='img img-fluid logo' alt='...' />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls='responsive-navbar-nav' />
            <Navbar.Collapse id='responsive-navbar-nav'>
              <Nav>
                <Nav.Link href='#' className='link'>Home</Nav.Link>
                <Nav.Link href='#about' className='link'>About Us</Nav.Link>
                <Nav.Link href='' className='link'>Blog</Nav.Link>
                <Nav.Link href='#contacts' className='link'>Contacts</Nav.Link>
              </Nav>
            </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  )
}

export default Navigationbar